module.exports = __webpack_public_path__ + "img/Login.2357f4cc.gif";